import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { useCallback, useEffect, useState } from 'react';
import { breakpointFamilyFromBreakpoint, breakpointNames, breakpoints, firstBreakpointName } from '../../css/breakpoints';
/** @internal */

export const layoutContextComputate = bks => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const bk = breakpointNames.reduce((carry, cb) => width >= bks[cb] ? cb : carry, firstBreakpointName);
  return O.some({
    width,
    height,
    breakpoint: bk,
    breakpointFamily: breakpointFamilyFromBreakpoint(bk)
  });
};
export const useLayoutDimension = () => {
  const [layout, setLayout] = useState(() => O.none);
  const layoutCalculator = useCallback(() => pipe(breakpoints, layoutContextComputate, setLayout), []);
  useEffect(() => {
    layoutCalculator();
    window.addEventListener('resize', layoutCalculator);
    return () => window.removeEventListener('resize', layoutCalculator);
  }, [layoutCalculator]);
  return layout;
};
//# sourceMappingURL=useLayoutDimension.js.map